(function($) {
    var circleElement = $('.careers-container .circle-item');
    var elementID = 0;

    // dynamically add animate attributes to intro block (for underline/arrow animation)
    if ( $('#careersBlock').length ) {
        $('.block-intro:first-of-type .heading-big .text-underline-heading')
            .attr({'data-animate': 'careersSuccess', 'data-arrow-target': 'arrowTarget'})
            .addClass('js-careers-arrow-src');
    }

    circleElement.each(function() {
        $this = $(this);
        var circleElementTarget = $this.attr('data-target');
        var circleElementTitle = $this.text();

        $this.on('click', function() {
            elementID++;
            $this = $(this);
            $this.addClass('is-active');
            $this.addClass('selected-' + elementID);

            // unlock button after 3 items are selected
            if($('.careers-container .circle-item.is-active').length === 1) {
                $('#careerSubmit')
                    .addClass('is-active')
                    .prop('disabled', false);
            } else if($('.careers-container .circle-item.is-active').length === 7) {
                aboutLeaderCompleted();

                // animate scroll down as arrow animates
                setTimeout(function() { 
                    $('html, body').animate({
                        scrollTop: $('#careersBlock').offset().top + 400
                    }, 500);
                }, 3500);
            }

            // append chart-circle element inside corresponding chart circle
            $('.careers-chart-circles .chart-item').each(function() {
                $this = $(this);
                var chartCircleID = 1;

                $this.find('.chart-circle').each(function() {
                    chartCircleID++                    
                });

                var chartCircleCount = $this.find('.chart-circle').length;
                var chartCircleElement = '<span class="chart-circle target-' + circleElementTarget + '-' + chartCircleID + '">' + circleElementTitle + '</span>';

                if ($this.hasClass(circleElementTarget) && chartCircleCount < 2) {
                    $(chartCircleElement).insertAfter('.' + circleElementTarget + " .chart-title" );
                }

            });

        });
    });

    $('#careerSubmit').on('click', function() {
        aboutLeaderCompleted();

        // animate scroll down as arrow animates
        setTimeout(function() { 
            $('html, body').animate({
                scrollTop: $('#careersBlock').offset().top + 400
            }, 500);
        }, 3500);
    });

    // complete animation after scrolling down the page
    $(window).scroll(function() {
        careersLeader = $('#careersBlock');

        if ($(window).width() >= 992 && careersLeader.length) {
            if ($(this).scrollTop() > 300) {
                aboutLeaderCompleted();
            }
        }
    });

    function aboutLeaderCompleted() {
        $('#careersPanel2').addClass('is-visible')
        $('#careersPanel1').removeClass('is-visible')
        $('.careers-arrow').addClass('is-visible');
        $('#careerSubmit').addClass('is-clicked');

        setTimeout(function() { 
            $('.leader-image-container').addClass('overlay-hidden');
        }, 500);

        setTimeout(function() { 
            $('[data-animate="careersSuccess"]')
                .append('<object type="image/svg+xml" data="/assets/images/scribbles/animated/scribble-underline-heading.svg" height="15" width="415">Hand drawn underline</object>')
            $('.js-careers-back').addClass('is-visible');
        }, 1600);
    }

}(jQuery));



// animated arrow
(function($) {

    // connecting scribble line setup
    scribbleLines = function() {

        if ( $('.js-careers-arrow-src').length ) {
            
             // src offset
            var elementSrcOffsetTop = $('.js-careers-arrow-src').offset().top;
            var elementSrcOffsetLeft = $('.js-careers-arrow-src').offset().left;

            // text offset
            var elementTargetOffsetTop = $('[data-arrow-target="arrowTarget"]').offset().top;
            var elementTargetOffsetLeft = $('[data-arrow-target="arrowTarget"]').offset().left;
            var elementTargetOffsetWidth = $('[data-arrow-target="arrowTarget"]').outerWidth();
            var elementTargetCenter = elementTargetOffsetWidth / 2;

            // width/height
            elementHeight = elementTargetOffsetTop - elementSrcOffsetTop;
            elementWidth = elementTargetOffsetLeft - elementSrcOffsetLeft

            var elementSubmitCircle = $('.js-careers-arrow-src').outerHeight();

            // careers arrow
            $('.js-careers-arrow').css({
                width: elementTargetCenter,
            });

        }

    };
    scribbleLines();

    $(window).resize(function() {
        scribbleLines();
    });

}(jQuery));
